import { Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import { Login } from './components/Login';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Imoveis } from './pages/Imoveis';
import { ImovelDetalhe } from './pages/ImovelDetalhe';
import { Lancamentos } from './pages/Lancamentos';

function Shell() {
  const { authed, loading } = useAuth();
  if (loading) {
    return <div className="min-h-full flex items-center justify-center text-slate-500">Carregando...</div>;
  }
  if (!authed) return <Login />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/imoveis" element={<Imoveis />} />
        <Route path="/imoveis/:id" element={<ImovelDetalhe />} />
        <Route path="/lancamentos" element={<Lancamentos />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}
